import { render, staticRenderFns } from "./stock_transfer.vue?vue&type=template&id=7c0b8dca"
import script from "./stock_transfer.vue?vue&type=script&lang=js"
export * from "./stock_transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports